module.exports = __webpack_public_path__ + "img/curly2.5cdea9b7.svg";